import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import BibCard from '../BibCard/BibCard';

import './BibSeries.scss';

export default class BibSeries extends React.PureComponent {
  renderItem(bib) {
    const bibId = bib.get('metadataId');
    const catalogBib = this.props.catalogBib;
    const isCurrentItem = catalogBib && bibId === catalogBib.get('metadataId');
    return <BibCard bib={bib} number={bib.get('volume')} key={bibId} isCurrentItem={isCurrentItem} />;
  }

  render() {
    const { bibs } = this.props;
    if (!bibs || !bibs.size) return null;
    return <div className="cp-bib-card-row">{bibs.map(bib => this.renderItem(bib))}</div>;
  }
}

BibSeries.propTypes = {
  bibs: ImmutablePropTypes.listOf(bibShape),
  catalogBib: catalogBibShape
};
